<template>
  <div v-if="item.price" class="product" @click.stop="$router.push(`/goods/info/${item.productno}`)">
    <el-image
      :src="item.thumbnailsImage"
      lazy
    ></el-image>
    <div class="title">{{ item.mercName }}</div>
    <div class="stock">{{ lang.stock }}：{{ item.canSaleCount }}{{ lang.unit }}</div>
    <div class="price">
      <template v-if="item.isgift === 2 && item.limitedstates === 2">
        <div class="item-price original"><span>{{ unit }}</span>{{ item.price.toFixed(2) }}</div>
        <div class="item-price"><span>{{ unit }}</span>{{ item.limitedtimeprice.toFixed(2) }}</div>
      </template>
      <template v-else-if="item.isgift === 4">
        <div class="item-price">
          <span>{{ unit }}</span>{{ item.integralprice.toFixed(2) }} + {{ item.integral }}{{ lang.integral }}
        </div>
      </template>
      <template v-else>
        <template v-if="item.pricediscount">
          <div class="item-price original"><span>{{ unit }}</span>{{ item.price.toFixed(2) }}</div>
          <div class="item-price">
            <span>{{ unit }}</span>{{ item.pricediscount.toFixed(2) }}
          </div>
        </template>
        <template v-else>
          <div class="item-price">
            <span>{{ unit }}</span>{{ item.price.toFixed(2) }}
          </div>
        </template>
      </template>
    </div>
    <div class="bottom">
      <!-- <div @click.stop.prevent style="display:inline">
        <el-input-number v-model="num" :min="1"></el-input-number>
      </div> -->
      <div
        class="add"
        :class="{ disabeld : item.canSaleCount <= 1 }"
      >{{ item.isgift === 2 && item.limitedstates === 2 ? lang.limit_buy : lang.add_cart }}</div>
    </div>
  </div>
</template>

<script>
import { getbuydetail } from '@/api/order'
import { mapGetters } from 'vuex'
export default {
  components: {},
  props: {
    item: Object
  },
  data() {
    return {
      num: 1
    }
  },
  computed: {
    lang() {
      return this.$t('goods')
    },
    ...mapGetters(['isLogin', 'location', 'unit'])
  },
  methods: {
    async buy(item) {
      if (item.canSaleCount <= 1) {
        return
      }
      await this.$checkLogin()
      const params = {
        productno: item.productno,
        buynum: this.num,
        isgift: item.isgift === 2 ? 2 : 0
      }
      getbuydetail(params).then((res) => {
        if (res.code === 1) {
          this.$router.push({
            path: '/order/confirm',
            query: params
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.product {
  margin: 0 18px 20px;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 12px;
  box-shadow: 7px 7px 9px 0px #f1f4f9;
  padding: 10px 15px 10px;
  /deep/ img {
    cursor: pointer;
    width: 216px;
    height: 216px;
  }
  .title {
    color: #4f4f4f;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .stock {
    padding: 4px 0 0;
    color: #aaaaaa;
    font-size: 12px;
  }
  .price {
    display: flex;
    align-items: flex-end;
    padding-bottom: 6px;
    .item-price {
      &.original {
        font-size: 10px;
        color: #000;
        margin-right: 10px;
        text-decoration: line-through;
      }
      font-size: 16px;
      color: #ff0000;
      span {
        font-size: 12px;
        padding-right: 6px;
      }
    }
  }
  .bottom {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .add {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #ec9221;
      min-width: 80px;
      padding: 0 10px;
      box-sizing: border-box;
      height: 24px;
      line-height: 24px;
      border-radius: 12px;
      color: #ffffff;
      font-size: 12px;
      &.disabeld {
        background-color: #aaa;
      }
    }
  }
}
/deep/ .el-input-number__increase,
/deep/ .el-input-number__decrease {
  top: 0;
  background: #aaa;
  border: 0;
  width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius: 4px;
  font-size: 14px;
  color: #ffffff;
}
/deep/ .el-input-number--small {
  width: 74px;
  line-height: 24px;
}
/deep/ .el-input-number {
  .el-input {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-input__inner {
    padding: 0;
    width: 28px;
    height: 20px;
    line-height: 20px;
    border: 1px solid #aaa;
    color: #000;
    font-size: 12px;
  }
}
</style>